import React from 'react';
import DialogComponent from '$components/DialogComponent';
import EndConsultationComponent from './EndConsultationComponent';
import {ConsultationOutcomePayload} from '$api/frontdesk';
import useAppointmentTimerSync, {
  TimerSyncData,
} from '../../../../hooks/useAppointmentTimerSync';

interface EndConsultationModalProps {
  open: boolean;
  handleClose: (open: boolean) => void;
  bookingId: number;
  user: {id: number; hospitalId?: number};
  patientId: number;
  outcomeForm: {
    description: string;
    surgery_listed: boolean;
    follow_up_required: boolean;
  };
  setOutcomeForm: React.Dispatch<
    React.SetStateAction<{
      description: string;
      surgery_listed: boolean;
      follow_up_required: boolean;
    }>
  >;
  sendConfirmConsultationOutcomeRequest: (
    data: ConsultationOutcomePayload
  ) => void;
  isPending: boolean;
  disableSubmit: boolean;
  onTimerEvent?: (data: TimerSyncData) => void;
}

const EndConsultationModal: React.FC<EndConsultationModalProps> = ({
  open,
  handleClose,
  bookingId,
  user,
  patientId,
  outcomeForm,
  setOutcomeForm,
  sendConfirmConsultationOutcomeRequest,
  isPending,
  disableSubmit,
  onTimerEvent,
}) => {
  useAppointmentTimerSync(
    open ? bookingId : undefined,
    (data: TimerSyncData) => {
      if (onTimerEvent) onTimerEvent(data);
    }
  );
  return (
    <DialogComponent
      open={open}
      handleClose={() => handleClose(false)}
      dialogTitle="End Consultation"
      dialogBody={
        <EndConsultationComponent
          bookingId={bookingId}
          user={user}
          patientId={patientId}
          outcomeForm={outcomeForm}
          setOutcomeForm={setOutcomeForm}
          sendConfirmConsultationOutcomeRequest={
            sendConfirmConsultationOutcomeRequest
          }
          isPending={isPending}
          disableSubmit={disableSubmit}
        />
      }
    />
  );
};

export default EndConsultationModal;
